import React, { ButtonHTMLAttributes } from 'react';
import classNames from 'classnames';
import type { FCWithChildren } from '../../types/FCWithChildren';

/*
a button with the traditional appearance of the html <a></a> tag (i.e. hyperlink).
* */
export const TextButtonTW: FCWithChildren<ButtonHTMLAttributes<HTMLButtonElement>> = ({
  children,
  className,
  ...rest
}) => {
  return (
    <button className={classNames('font-medium text-blue-600 hover:underline dark:text-blue-500', className)} {...rest}>
      {children}
    </button>
  );
};
